import { render, staticRenderFns } from "./FacultyByCoordinator.vue?vue&type=template&id=7e504e34&scoped=true&"
import script from "./FacultyByCoordinator.vue?vue&type=script&lang=js&"
export * from "./FacultyByCoordinator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e504e34",
  null
  
)

export default component.exports